import { Component, Inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { IdentityService } from '../../core/identity/identity.service';
import { Logger, LoggerFactory } from '../../core/logger.service';
import { SiteSpecific, UserSession } from '../../core/site-specific.base';
import { Environment, ENVIRONMENT_DI } from '../../environment/environment';
import { SnackBarService } from '../../core/snack-bar.service';
import { LanguageService } from '../../core/language.service';
import { BrandVariablesService } from 'app/account/brand-variables.service';

@Component({
  selector: 'app-verify-user-message',
  templateUrl: './verify-user-message.component.html',
  styleUrls: ['./verify-user-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VerifyUserMessageComponent extends SiteSpecific {
  @Input() sideMenuIsOpen: boolean;
  private readonly logger: Logger;
  public emailSendingInProgress = false;

  constructor(
    protected loggerFactory: LoggerFactory,
    private readonly identityService: IdentityService,
    private readonly languageService: LanguageService,
    protected readonly userSession: UserSession,
    @Inject(ENVIRONMENT_DI) private readonly environment: Environment,
    private readonly snackbarService: SnackBarService,
    private brandVariablesService: BrandVariablesService,
  ) {
    super(userSession, loggerFactory);
    this.logger = loggerFactory.get('EmailRegistrationComponent');
  }

  protected async onSiteChanged() {
    this.checkIfVerifyEmailMessageShouldShow();
  }

  private checkIfVerifyEmailMessageShouldShow() {
    if (
      this.identityService.hasCurrentIdentity &&
      !this.identityService.currentIdentity.isVerified &&
      this.identityService.isUserVerified
    ) {
      this.brandVariablesService.showVerifyEmailMessage.next(true);
    } else {
      this.brandVariablesService.showVerifyEmailMessage.next(false);
    }
  }

  public closeMessageBox() {
    this.brandVariablesService.showVerifyEmailMessage.next(false);
  }

  get showVerifyEmailMessage() {
    return this.brandVariablesService.showVerifyEmailMessage.value;
  }

  public async resendVerificationEmail() {
    this.logger.debug('RESEND VERIFICATION EMAIL');
    const callbackPath = '/account/confirm';
    const emailAddress = this.identityService.currentIdentity.email;
    let language = await this.languageService.getCurrentLanguageNameAsync();
    if (!language) {
      language = 'English';
    }
    this.emailSendingInProgress = true;
    const emailSent = await this.identityService.resendVerificationEmailAsync(emailAddress, callbackPath, language);
    this.emailSendingInProgress = false;

    if (emailSent) {
      this.snackbarService.success('registration.sendVerificationSuccess');
    } else {
      this.snackbarService.error('registration.sendVerificationError');
    }
  }
}
